import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { RootState } from '../redux/store';
import { setTreatment } from '../redux/slices/appointmentSlice';
import { StepCard } from '../components/StepCard';
import { Button } from '../components/Button';
import { InputCard } from '../components/InputCard';
import { Stethoscope } from 'lucide-react';


export const StepTreatment = () => {
  const selected = useSelector((s: RootState) => s.appointment.treatment);
  const { practice } = useSelector((s: RootState) => s.auth);
  const treatments  = practice?.appointment_types || [];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const proceed = () => {
    navigate(`/bookonline/step-2`);
  };
  return (
    <Layout>
      <div className="space-y-4">
        <div>
          <h1 className="text-2xl font-semibold text-black">Treatment type</h1>
          <p className="text-sm text-gray-500">Choose the service you'd like to schedule</p>
        </div>
        <StepCard>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {treatments.map(t => {
              const isSelected = selected?.id === t.id;
              return (
                <InputCard
                  key={t.id}
                  title={t.title}
                  isSelected={isSelected}
                  onClick={() => dispatch(setTreatment(t))}
                  variant="treatment"
                  icon={<Stethoscope size={24} className="text-blue-600"/>}
                />
              );
            })}
          </div>
        </StepCard>

        <div className="flex justify-between">
          <span />
          <Button title='Continue' disabled={!selected?.id} onClick={proceed}/>
        </div>
      </div>
    </Layout>
  );
};




